import React, { useState } from 'react';
import StatusPage from '../../components/StatusPage/StatusPage';
import LinkButton from '../../components/LinkButton/LinkButton';
import CancelMonitoringModal from '../../components/CancelMonitoringModal/CancelMonitoringModal';
import { Actions } from './RejectedStyles';

const Rejected = () => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  return (
    <>
      <StatusPage icon="fas fa-exclamation-circle" iconColor="#dd6c64" accentColor="#fde1e6">
        Unfortunately, your enrollment was rejected by Experian.
        <Actions>
          <LinkButton onClick={() => setIsCancelModalOpen(true)}>Cancel my enrollment</LinkButton>
        </Actions>
      </StatusPage>
      <CancelMonitoringModal
        isOpen={isCancelModalOpen}
        onRequestClose={() => setIsCancelModalOpen(false)}
      />
    </>
  );
};

export default Rejected;
